import { render, staticRenderFns } from "./ActionsItUnSubscribe.vue?vue&type=template&id=3656f1e7&scoped=true&"
import script from "./ActionsItUnSubscribe.vue?vue&type=script&lang=js&"
export * from "./ActionsItUnSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656f1e7",
  null
  
)

export default component.exports